module.exports = __webpack_public_path__ + "img/n8.37e40252.png";